<template>
  <div>
    <div class="card">
      <header class="header-card">
        <p>{{ $t('rapprochementAchat.rapprochement')}}</p>
      </header>
      <div class="card-content">
        <div class="columns">
          <div class="column is-4">
            <b-field :label="$t('rapprochementAchat.typeRapprochement')"
            class="obligatoire hex-text-default">
              <b-select v-model="moduleType" expanded disabled>
                <option v-for="type in typeRapprochement"
                        :key="type.code"
                        :value="type.code">
                  {{ $t(type.libelle) }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-4">
            <b-field
              :label="$t('rapprochementAchat.rechercheBy')"
              class="hex-text-default">
                <qd-taginput
                  v-model="query.codesDossier"
                  type="is-primary"
                  ellipsis
                  @input="$emit('refresh')">
                </qd-taginput>
            </b-field>
          </div>
          <div v-if="moduleType === constantes.MODULE_BAIL" class="column is-4">
            <b-field :label="$t('rapprochementAchat.periodeRecherche')"
                     class="hex-text-default">
              <date-picker :dates='query.datesPremierAffichage'
                           :updateEndDateAtChangeStartDate="false"
                           :customMove="true" @recherche="$emit('refresh')"
              position="is-top-left"/>
            </b-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import datePicker from '@/components/general/datePicker';
import { MODULE_TLPE } from '@/configuration/gabed/titreRecette/titreRecetteConf';
import { MODULE_BAIL, MODULE_ACHAT } from '@/configuration/devisConf';

export default {
  name: 'filtreRapprochement',
  data() {
    return {
      constantes: {
        MODULE_BAIL,
      },
      typeRapprochement: [
        { code: MODULE_BAIL, libelle: 'rapprochementAchat.type.bail' },
        { code: MODULE_TLPE, libelle: 'rapprochementAchat.type.tlpe' },
        { code: MODULE_ACHAT, libelle: 'rapprochementAchat.type.achat' },
      ],
    };
  },
  components: {
    datePicker,
  },
  props: {
    facture: {
      type: Object,
      required: true,
    },
    moduleType: {
      type: String,
      required: true,
    },
    query: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>

</style>
